import { useContext, useState } from "react";
import { FormDataContext } from "./FormDataContext";

/**
 * Custom hook to access and update form data from FormDataContext.
 * Ensures any component using this hook can read and update quote form state.
 */
export const useFormData = () => {
    // Access the context value provided by FormDataProvider
    const { formData, setFormData } = useContext(FormDataContext);
    const [formErrors, setFormErrors] = useState([]);

    /**
     * Helper function to update a specific field in the form data.
     * It merges the new value with the existing state.
     *
    * @param {string} field - The key to update in formData
    * @param {*} value - The new value for the field
    */
    const updateField = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));

        setFormErrors(prevErrors => prevErrors.filter(err => {
            if (field === "quoteText" && value?.trim()) return err.input !== "quoteText";
            return true;
        }));
    };

    const updateNestedField = (parentField, childField, value) => {
        setFormData(prev => ({
            ...prev,
            [parentField]: {
                ...prev[parentField],
                [childField]: childField === "referenceLinks" ? [value] : value
            }
        }));

        if (parentField === "article") {
            setFormErrors(prevErrors => prevErrors.filter(err => {
                if (childField === "title" && value?.trim()) return err.input !== "articleTitle";
                if (childField === "articleHtml" && value?.trim()) return err.input !== "articleBody";
                return true;
            }));
        }
    };

    return { 
        formData, 
        updateField, 
        updateNestedField,
        formErrors,
        setFormData,
        setFormErrors,
    };
};
